module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', [_c('div', {
    staticClass: "aio-container"
  }, [_c('div', {
    staticClass: "home-header"
  }, [_c('h1', {
    staticClass: "subtile-home"
  }, [_vm._v("Sélectionnez votre bureau")]), _vm._v(" "), _c('div', {
    staticClass: "link-menu"
  }, [_c('div', {
    staticClass: "management-btn",
    on: {
      "click": function($event) {
        return _vm.manageTeam()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "auto",
      "cursor": "pointer"
    },
    attrs: {
      "src": require("../../assets/bouton-gestion-des-equipes.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "disconnect",
    on: {
      "click": function($event) {
        return _vm.goTo('logout')
      }
    }
  }, [_c('p', [_vm._v("Déconnexion")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "home-content-wrapper"
  }, [_c('div', {
    staticClass: "team-wrapper"
  }, [_c('b-row', _vm._l((_vm.offices), function(desk, name, index) {
    return _c('b-col', {
      key: index
    }, [_c('h4', {
      staticClass: "label team-name"
    }, [_vm._v(" " + _vm._s(name))]), _vm._v(" "), _c('hr', {
      staticClass: "label-separator"
    }), _vm._v(" "), _c('div', {
      staticClass: "btn-group-team-selection"
    }, _vm._l((desk), function(team, nameTeam, index) {
      return _c('b-button', {
        key: index,
        staticClass: "btn-team-selection",
        on: {
          "click": function($event) {
            return _vm.goToRoute('/kanban-board/' + name + '/' + nameTeam)
          }
        }
      }, [_vm._v("\n                " + _vm._s(nameTeam) + "\n              ")])
    }), 1)])
  }), 1)], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('team-update-modal', {
    ref: "update-team",
    attrs: {
      "offices": _vm.offices
    },
    on: {
      "supdate-done": _vm.updateData
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3659c162","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/HomePage.vue
// module id = 710
// module chunks = 1